import React, { useContext } from "react";

export const RouletteContext = React.createContext(null);

export const useRoulette = () => {
    const context = useContext(RouletteContext);

    if (!context) {
        throw new Error("useRoulette must be used inside RouletteProvider");
    }

    return context;
};